import React, { useEffect, useState } from "react";

import CreateClaimEstateModal from "./components/create-claim-modal/Modal";
import CreateOtherProductClaimModal from "./components/create-other-product-claim-modal/Modal";
import NewClaimDropdown from "./components/NewClaimDropdown";
import ModalInstructions from "./components/ModalInstructions";
import Table from "./components/Table";
import { connect } from "react-redux";
import { CustoDropDownItemProps } from "../../components/types";
import { iRootDispatch, iRootState } from "../../store";
import { AvailableBrokersAndEstatesState } from "../../store/types/temp-types";
import GeneralCondition from "./components/GeneralCondition";
import AuthorizationContainer from "../../components/AuthorizationContainer";
import { ActionEnum } from "../../enums/authz-action.enum";
import { FeatureEnum } from "../../enums/authz-feature.enum";
import { ClaimProductTypeEnum } from "./enums/ClaimProductType.enum";

const ClaimEstateIndex = (props: any) => {
  const { availableBrokersAndEstates } = props;
  const brokers: CustoDropDownItemProps[] = availableBrokersAndEstates.brokers;
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [openConditions, setOpenConditions] = useState<boolean>(false);
  const [broker, setBroker] = useState<any>();
  const [openBondClaimModal, setOpenBondClaimModal] = useState(false);
  const [openOtherProductClaimModal, setOpenOtherProductClaimModal] = useState(false);
  const [selectedProductType, setSelectedProductType] = useState<ClaimProductTypeEnum>(
    ClaimProductTypeEnum.FIRE
  );

  const toggleOpen = () => {
    setOpenModal(true);
  };

  const toggleClose = () => {
    setOpenModal(false);
  };

  const toggleOpenConditions = () => {
    setOpenConditions(true);
  };

  const toggleCloseConditions = () => {
    setOpenConditions(false);
  };

  const handleSelectClaimProduct = (productType: ClaimProductTypeEnum) => {
    if (productType === ClaimProductTypeEnum.BOND) {
      setOpenBondClaimModal(true);
      return;
    }

    setSelectedProductType(productType);
    setOpenOtherProductClaimModal(true);
  };

  useEffect(() => {
    if (!!brokers.length) {
      setBroker(brokers[0].value);
    }
  }, [brokers]);

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          gap: 16,
          marginBottom: 12,
          flexWrap: "wrap"
        }}
      >
        <AuthorizationContainer action={ActionEnum.create} feature={FeatureEnum.claims}>
          <NewClaimDropdown onSelect={handleSelectClaimProduct} />
        </AuthorizationContainer>

        <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end" }}>
          <ModalInstructions
            openModal={openModal}
            toggleOpen={toggleOpen}
            toggleClose={toggleClose}
          />
          <GeneralCondition
            openModal={openConditions}
            toggleOpen={toggleOpenConditions}
            toggleClose={toggleCloseConditions}
          />
        </div>
      </div>

      <Table />

      {openBondClaimModal && (
        <CreateClaimEstateModal
          onlyModal
          onClose={() => setOpenBondClaimModal(false)}
        />
      )}

      <CreateOtherProductClaimModal
        open={openOtherProductClaimModal}
        productType={selectedProductType}
        onClose={() => setOpenOtherProductClaimModal(false)}
      />
    </>
  );
};

const mapState = (state: iRootState) => ({
  availableBrokersAndEstates: state.availableBrokersAndEstates,
  user: state.user,
});

const mapDispatch = (dispatch: iRootDispatch) => ({
  updateAvailableBrokersAndEstates: (
    availableBrokers: AvailableBrokersAndEstatesState
  ) =>
    dispatch.availableBrokersAndEstates.updateAvailableBrokersAndEstates(
      availableBrokers
    ),
});

export default connect(mapState, mapDispatch)(ClaimEstateIndex);
